/**
 * Authentication Helpers
 * 
 * Helper functions for authentication operations, including cache clearing
 * and state reset for EspoCRM integration.
 */

import { clearCredentials } from './authSlice';

/**
 * Performs a complete logout, clearing all caches and resetting state
 */
export async function performLogout(): Promise<void> {
  // Lazy import to avoid circular dependency with store.ts
  const { store } = await import('src/store');
  const { activeTenant } = await import('src/drheranca');
  const { getAuthApi } = await import('src/core/auth/api/authApi');

  // Reset RTK Query caches
  try {
    // Reset tenant API cache
    if (activeTenant.api && 'util' in activeTenant.api) {
      store.dispatch(activeTenant.api.util.resetApiState());
    }
    
    // Reset auth API cache
    const authApi = getAuthApi();
    if (authApi && 'util' in authApi) {
      store.dispatch(authApi.util.resetApiState());
    }
  } catch (error) {
    console.warn('Failed to reset API caches:', error);
  }
  
  // Clear credentials from Redux store
  store.dispatch(clearCredentials());
  
  // Force navigation to home page
  // Use window.location to ensure a full page reload and clear any route state
  window.location.href = '/';
}
